import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';

import { MediaItemIndexed } from '../../types/media-item-indexed.type';

@Component({
  selector: 'app-lot-carousel-thumbs',
  templateUrl: './lot-carousel-thumbs.component.html',
  styleUrls: ['./lot-carousel-thumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotCarouselThumbsComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() title?: string;
  @Input() media: MediaItemIndexed[] = [];
  @Input() visibleRowLimit?: number;
  @Input() hasExtraThumb = false;

  @Output() activeSlideIndexChanged = new EventEmitter();

  expanded = false;
  showExpandButton = false;
  visibleThumbsCount = 0;

  get displayedMedia(): MediaItemIndexed[] {
    return this.media;
  }

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly host: ElementRef<HTMLElement>,
  ) {}

  ngOnInit(): void {
    this.visibleThumbsCount = this.displayedMedia.length;
  }

  ngAfterViewInit(): void {
    this.updateDisplayedMedia();
  }

  ngOnChanges(): void {
    if (this.media.length) {
      this.updateDisplayedMedia();
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateDisplayedMedia();
  }

  private updateDisplayedMedia(): void {
    const thumbsInRow = this.calculateThumbsInRow();

    if (!this.visibleRowLimit || thumbsInRow === null) {
      this.visibleThumbsCount = this.displayedMedia.length;
      this.showExpandButton = false;
      this.cdr.markForCheck();
      return;
    }

    const maxVisibleCount = this.visibleRowLimit * thumbsInRow;
    this.showExpandButton = this.displayedMedia.length > maxVisibleCount;

    if (this.expanded) {
      this.visibleThumbsCount = this.displayedMedia.length;
    } else {
      this.visibleThumbsCount = maxVisibleCount;
    }

    this.cdr.markForCheck();
  }

  toggleExpand(): void {
    this.expanded = !this.expanded;
    this.updateDisplayedMedia();
  }

  trackBySource(_: number, mediaItem: MediaItemIndexed): string {
    return mediaItem.source;
  }

  private calculateThumbsInRow(): number | null {
    const host = this.host.nativeElement;
    const row = host.querySelector('nz-row');
    const thumb = host.querySelector('nz-col');

    if (thumb && row) {
      const rowWidth = row.clientWidth;
      const thumbWidth = thumb.clientWidth;

      if (rowWidth && thumbWidth) {
        return Math.round(rowWidth / thumbWidth);
      }
    }

    return null;
  }
}
